<template>
    <div class="careers-container">

        <div class="intro" v-bind:style="{ backgroundImage: image_url() }">

            <div class="overlay">

                <div class="wrapper">
                    <p class="subline">CAREER</p>
                    <h1 class="headline">JOIN US</h1>

                    <p class="keywords">
                        If you thrive on amazingly professional, playful and supportive working environment see available roles.
                    </p>

                    <a class="anim_button" @click="scrollPageHeight()">
                        <p>SEE MORE INFO</p>
                        <div class="span_bg"></div>
                    </a>

                </div>

                <div class="bottom__bar">

                    <div class="text-wrap">
                        <p class="red_text">TEAM</p>
                        <p class="regular_text">MEMBER</p>
                        <p class="red_text second">00</p>
                    </div>

                </div>

            </div>

        </div>

        <div class="content">

            <div class="perks__slider">
                <p class="title">PERKS</p>

                <perks-slider></perks-slider>
            </div>

            <div class="career_box">
                <div class="column__text">
                    <p class="subline">informations</p>
                    <p class="headline">Mens sana in corpore sano</p>
                    <p class="text">
                        We care about health! Healthy nutrition and regular workout lead to a healthy and ready for challenges mind. This is the reason why two of our company's goals are a in-house kitchen led by a professional chef and custom gym memberships with dedicated prices for our employees.
                    </p>

                    <!-- <a class="action__btn left" href="/contact">
                        <p>CONTACT US</p>
                        <div class="span_bg"></div>
                    </a> -->
                </div>
                <div class="image first" v-bind:style="{ backgroundImage: get_careers_image(1) }"></div>
            </div>

            <div class="career_box reverse">
                <div class="column__text">
                    <p class="subline">informations</p>
                    <p class="headline">Breaks help concentration</p>
                    <p class="text">
                        Several researches have revealed that the average adult human is only able to fully concentrate on a task for a certain amount of time: a gaming spot, a well-furnished fridge, and a coffee machine will be at your disposal anytime you need to relax and regain concentration.
                    </p>
                    <!-- <a class="action__btn right" href="/contact">
                        <p>SEND MESSAGE</p>
                        <div class="span_bg"></div>
                    </a> -->
                </div>
                <div class="image second" v-bind:style="{ backgroundImage: get_careers_image(2) }"></div>
            </div>

            <div class="career_box">
                <div class="column__text">
                    <p class="subline">informations</p>
                    <p class="headline">Hard work pays off</p>
                    <p class="text">
                        We believe in you and your growth within our company: bonuses, salary increase and paid employee trainings for any activity that is beneficial to your position at Gate21 is a must with us. Knowledge is power, and therefore we as a company strive to work with those dedicated to gaining knowledge.
                    </p>
                    <!-- <a class="action__btn left" href="/contact">
                        <p>REACH US</p>
                        <div class="span_bg"></div>
                    </a> -->
                </div>
                <div class="image third" v-bind:style="{ backgroundImage: get_careers_image(3) }"></div>
            </div>

            <div class="career_box reverse">
                <div class="column__text">
                    <p class="subline">informations</p>
                    <p class="headline">Free Time</p>
                    <p class="text">
                        Our company values work-life balance and offers paid holidays and vacation days as part of our benefits package. This ensures employees have time to recharge, leading to higher productivity and job satisfaction. Time is precious, you can make more money, but you can't make more time; we recognize that and we are willing to go the extra mile to support our employees and their free time.
                    </p>
                    <!-- <a class="action__btn left" href="/contact">
                        <p>REACH US</p>
                        <div class="span_bg"></div>
                    </a> -->
                </div>
                <div class="image fourth" v-bind:style="{ backgroundImage: get_careers_image(4) }"></div>
            </div>

            <AvailableRoles/>

            <career-form/>

        </div>

    </div>
</template>
<script>
    export default {
        data(){
            return {
                // text: "Vue3 component."
            }
        },
        props: ['hero_image', 'first_image', 'second_image', 'third_image', 'fourth_image'],
        methods: {
            scrollPageHeight(){
                const height = window.innerHeight - document.getElementsByTagName('header')[0].clientHeight;
                window.scrollBy(0, height);
            },
            image_url(){
                return "url('" + this.hero_image.media_URL + "')"
            },
            get_careers_image(image_num){
                switch (image_num) {
                    case 1:
                        return "url('" + this.first_image.media_URL + "')"
                        break;

                    case 2:
                        return "url('" + this.second_image.media_URL + "')"
                        break;

                    case 3:
                        return "url('" + this.third_image.media_URL + "')"
                        break;

                    case 4:
                        return "url('" + this.fourth_image.media_URL + "')"
                        break;
                
                    default:
                        break;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    .careers-container{

        .intro{
            position: relative;
            height: 100vh;

            // background: url('/images/careers/page_header.webp');
            background-repeat: no-repeat;
            // background-position: center -140px;
            // background-position: -40px center;
            background-position: center;
            background-size: cover;
            background-color: black;

            .overlay{
                display: block;
                width: 100%;
                height: 100%;
                position: relative;

                background: rgba(92, 44, 144, 0.6);

                .wrapper{
                    display: block;
                    position: absolute;
                    top: 57%; right: 50%;
                    transform: translate(50%, -50%);
                    // width: 976px;
                    width: 100%;
                    max-width: 623px;
                    height: auto;

                    .subline{
                        font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        // font-weight: 700;
                        font-size: 50px;
                        line-height: 60px;
                        /* identical to box height */

                        text-align: center;

                        color: #ED1163;
                        margin: 0;
                        text-align: left;
                    }

                    .headline{
                        font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        font-weight: 700;
                        font-size: 175px;
                        line-height: 175px;
                        /* identical to box height */

                        color: #FFFFFF;
                        margin: 0;

                        margin-left: -5px;
                    }

                    .keywords{
                        font-family: 'DIN Next LT Pro UltraLight', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        font-size: 22px;
                        line-height: 30px;
                        /* or 136% */

                        margin: 0;
                        margin-top: 22px;
                        text-align: center;
                        width: 100%;
                        max-width: 454px;
                        margin-left: auto;
                        margin-right: auto;

                        color: #FFFFFF;
                    }

                    a.anim_button{
                        display: block;
                        background: rgba(15, 15, 15, 0.3);
                        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                        width: 409px;
                        height: 50px;
                        margin-bottom: -9px;
                        cursor: pointer;
                        user-select: none;
                        position: relative;
                        overflow-y: hidden;
                        z-index: 4;
                        text-decoration: none;
                        margin-top: 93px;
                        margin-left: auto;
                        margin-right: auto;

                        p{
                            font-family: "DIN Next LT Pro Medium", Tahoma, Verdana, sans-serif;
                            font-style: normal;
                            // font-weight: 700;
                            font-size: 20px;
                            line-height: 54px;
                            text-align: center;
                            letter-spacing: 0.2em;
                            text-transform: uppercase;
                            margin: 0 auto;

                            color: #FFFFFF;
                            position: relative;
                            z-index: 4;
                        }

                        div.span_bg{
                            background: linear-gradient(90deg, #ED1163 0%, #5C2C90 96.27%);
                            height: 100%;
                            width: 100%;
                            transition: all .3s ease-in-out;
                            margin-top: auto;
                            margin-bottom: 0;
                            opacity: 0;

                            position: absolute;
                            bottom: -50px;
                            z-index: 3;
                        }

                        &:hover{
                            div.span_bg{
                                height: calc(100%);
                                bottom: 0;
                                opacity: 1;
                            }
                        }
                    }
                }

                .bottom__bar{
                    background: linear-gradient(360deg, #1A1A1A -0.25%, #222222 100%);
                    height: 64px;
                    width: 100%;
                    position: absolute;
                    bottom: 0;

                    border-top: 1px solid #ED1163;
                    border-bottom: 1px solid #ED1163;

                    .text-wrap{
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        position: relative;
                        margin-top: 20px;

                        .red_text{
                            font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;
                            font-style: normal;
                            font-size: 25px;
                            line-height: 25px;
                            /* or 100% */

                            color: #ED1163;
                            margin: 0;

                            &.second{
                                margin-left: 24px;
                            }
                        }

                        .regular_text{
                            font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;
                            font-style: normal;
                            font-size: 25px;
                            line-height: 25px;
                            /* or 100% */

                            color: #ffffff;
                            margin: 0;
                            margin-left: 8px;
                        }
                    }

                    
                }
            }
        }

        .content{
            padding: 115px 0;
            background: linear-gradient(180deg, #2A1542 0%, #000000 100%);
            display: flex;
            flex-direction: column;
            justify-content: center;

            .perks__slider{
                margin-bottom: 115px;
                // width: 100%;
                width: calc(100% - 22px);
                max-width: 950px;
                margin-left: auto;
                margin-right: auto;
                margin-top: 0;

                p.title{
                    font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                    font-style: normal;
                    // font-weight: 700;
                    font-size: 30px;
                    line-height: 36px;
                    margin-bottom: 70px;

                    margin-top: 0;

                    color: #FFFFFF;
                }
            }

            .career_box{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                width: 100%;
                max-width: 1140px;
                margin: auto;
                margin-bottom: 145px;

                &.reverse{
                    flex-direction: row-reverse;

                    .column__text{
                        margin-right: 0;
                        margin-left: auto;
                    }
                }


                .column__text{
                    display: flex;
                    flex-direction: column;

                    margin-left: 0;
                    margin-right: auto;

                    .subline{
                        font-family: 'DIN Next LT Pro Bold';
                        font-style: normal;
                        // font-weight: 700;
                        font-size: 14px;
                        line-height: 17px;

                        color: #ED1163;

                        margin: 0;
                        text-transform: uppercase;
                        margin-top: auto;
                    }

                    .headline{
                        font-family: 'DIN Next LT Pro Bold';
                        font-style: normal;
                        // font-weight: 700;
                        font-size: 30px;
                        line-height: 36px;

                        color: #FFFFFF;

                        margin: 0;
                        text-transform: uppercase;
                    }

                    .text{
                        font-family: 'DIN Next LT Pro Light';
                        font-style: normal;
                        // font-weight: 400;
                        font-size: 16px;
                        line-height: 19px;

                        color: #FFFFFF;

                        margin: 0;
                        width: 100%;
                        max-width: 470px;

                        margin-bottom: auto;
                    }
                }

                .image{
                    display: block;
                    width: 500px;
                    height: 500px;

                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: cover;
                    background-color: black;
                    // filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));

                    &.first{
                        // background: url('/images/careers/first.webp');
                        // background: url('/images/careers/third.webp');
                    }

                    &.second{
                        // background: url('/images/careers/second.webp');
                    }

                    &.third{
                        // background: url('/images/careers/third.webp');
                        // background: url('/images/careers/jobs/rm.webp');
                        background-size: cover;
                        background-position: center;
                    }

                    &.fourth{
                        // background: url('/images/careers/first.webp');
                    }

                }

            }

        }
    }

    .action__btn{
        display: block;
        background: rgba(15, 15, 15, 0.3);
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        width: auto;
        min-width: 230px;
        height: 50px;
        // margin-bottom: -9px;
        cursor: pointer;
        user-select: none;
        position: relative;
        overflow-y: hidden;
        z-index: 4;
        text-decoration: none;
        margin-top: auto;
        margin-bottom: 0;
        border: 1px solid #ED1163;

        &.left{
            margin-left: 0;
            margin-right: auto;
        }

        &.right{
            margin-right: 0;
            margin-left: auto;
        }

        p{
            font-family: "DIN Next LT Pro Medium", Tahoma, Verdana, sans-serif;
            font-style: normal;
            // font-weight: 700;
            font-size: 20px;
            line-height: 54px;
            text-align: center;
            letter-spacing: 0.2em;
            text-transform: uppercase;
            margin: 0 auto;

            color: #FFFFFF;
            position: relative;
            z-index: 4;
        }

        div.span_bg{
            background: linear-gradient(90deg, #ED1163 0%, #5C2C90 96.27%);
            height: 100%;
            width: 100%;
            transition: all .3s ease-in-out;
            margin-top: auto;
            margin-bottom: 0;
            opacity: 0;

            position: absolute;
            bottom: -50px;
            z-index: 3;
        }

        &:hover{
            div.span_bg{
                height: calc(100%);
                bottom: 0;
                opacity: 1;
            }
        }
    }

    .perks__slider{
        margin-top: 40px;

        p{
            text-align: center;
        }
    }

    @media screen and (max-width: 1280px) {
        .careers-container{
            .content{
                .career_box{
                    max-width: 1040px;

                    .image{
                        width: 400px;
                        height: 400px;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 836px) {
        .careers-container{

            .intro{
                
                .overlay{

                    .wrapper{
                        width: 100%;

                        .subline{
                            font-size: 20px;
                            line-height: 24px;
                            text-align: center;
                            margin-bottom: 15px;
                        }

                        .headline{
                            font-size: 40px;
                            line-height: 40px;
                            text-align: center;
                        }

                        .keywords{
                            font-size: 16px;
                            line-height: 16px;
                        }

                        a.anim_button{
                            width: 100%;
                            max-width: 245px;
                            height: 35px;
                            
                            p{
                                font-size: 12px;
                                line-height: 40px;
                            }
                        }
                    }

                    .bottom__bar{
                        .text-wrap{
                            .red_text, .regular_text, .red_text.second{
                                font-family: 'DIN Next LT Pro Light', Tahoma, Verdana, sans-serif;
                                font-size: 18px;
                                line-height: 25px;
                            }   
                        }
                    }
                }
            }


            .content{
                padding: 0;

                .perks__slider{
                    margin-top: 115px;
                }

                .career_box, .career_box.reverse{
                    flex-direction: column;
                    width: 90%;

                    .action__btn{
                        display: none;
                        // margin: 24px auto;
                    }

                    .image{
                        width: 100%;
                        height: 300px;
                        background-position: center !important;
                    }

                    .column__text{
                        margin-bottom: 14px;
                    }
                }
            }
        }
    }

</style>